/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_File_Too_LargeInputs */

const en_error_file_too_large = /** @type {(inputs: Error_File_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The file is larger than 10 MB.`)
};

/**
* | output |
* | --- |
* | "The file is larger than 10 MB." |
*
* @param {Error_File_Too_LargeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_file_too_large = /** @type {((inputs?: Error_File_Too_LargeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_File_Too_LargeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_file_too_large(inputs)
});